import React from 'react'
import styled from '@emotion/styled';
import PropTypes from 'prop-types'


const ResultadoDiv = styled.div`
    background-color: #66A2FE;
    color: #000;
    padding: 2rem;
    border-radius: 10px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    margin-top:2rem;
`
const Parrafo = styled.p`
    font-size: 18px;
    span {
        font-weight: bold;
    }
`
const Precio = styled.span`
    font-size: 30px;
    span {
        font-weight: bold;
    }
`

const Cotizacion = ({resultado}) => {
    
    if (Object.keys(resultado).length === 0) return null;

    return ( 

        <ResultadoDiv>
            <Precio>El precio es: <span>{resultado.PRICE}</span></Precio>
            <Parrafo>El precio mas alto del día es: <span>{resultado.HIGHDAY}</span></Parrafo>
            <Parrafo>El precio mas bajo del es: <span>{resultado.LOWDAY}</span></Parrafo>
            <Parrafo>Ultimas 24HS: $ <span>{resultado.CHANGEPCT24HOUR}</span></Parrafo>
            <Parrafo>Ultima Actualizacíon: <span>{resultado.LASTUPDATE}</span></Parrafo>

        </ResultadoDiv>

     );
}

Cotizacion.propTypes = {
    resultado: PropTypes.object.isRequired
}
 
export default Cotizacion;